import { Box } from '@mui/material'
import { Colors } from '@foxtail-dev/user-clients'
import { FoxTypography } from '../common/FoxTypography'
import { SaveIcon } from '../icons/SaveIcon'

export const CancelingImportListingSession = () => {
    return (
        <Box sx={styles.container}>
            <SaveIcon color={Colors.light.tertiary} height={70} width={200} />
            <FoxTypography variant='h6' sx={styles.text}>
                Your import session is cancelling. <br />
                You can start a new import once it finishes
            </FoxTypography>
        </Box>
    )
}

const styles = {
    container: {
        height: '600px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        flexDirection: 'column'
    },
    text: {
        color: Colors.light.tertiary,
        marginTop: '48px',
        textAlign: 'center',
        marginLeft: '30px',
        marginRight: '30px'
    }
}
